// src/pages/CookiePolicyPage.jsx
// Linked from the cookie banner. Same layout as ShippingPolicyPage.jsx. The
// cookie list mirrors what Google Analytics and Google Ads set on this site;
// re-check it with Tixaru > Settings > Website Cookies after adding any tag.
import React from "react";
import "./ContactPage.css";
import Footer from "../Footer";
import { openCookieSettings } from "../utils/cookieConsent";

const COOKIES = [
  ["Essential", "Local storage: biba_cookie_consent", "Remembers your cookie choice", "12 months"],
  ["Analytics", "_ga, _ga_F3TSVWDW2H, _ga_LWW7ESD9ZY", "Google Analytics: counts visitors and the pages they view", "2 years"],
  ["Advertising", "_gcl_au, IDE", "Google Ads: measures whether an ad click led to an enquiry or purchase", "90 days to 13 months"],
];

const CookiePolicyPage = () => {
  return (
    <div className="cp-root">
      <div className="cp-breadcrumb-bar">
        <div className="cp-breadcrumbs">
          <a href="/">Home</a>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">Cookie Policy</span>
        </div>
      </div>

      <section className="cp-rfq-section">
        <div className="cp-wrap" style={{ maxWidth: 860 }}>
          <span className="cp-badge">PRIVACY</span>
          <h1 style={{ margin: "16px 0 24px", fontSize: "2rem" }}>Cookie Policy</h1>

          <div style={{ fontSize: "1rem", lineHeight: 1.8, color: "#374151" }}>
            <p>
              Cookies are small files a website stores in your browser. bibaelectronics.com uses essential
              storage to work and, only if you agree, analytics and advertising cookies from Google. Nothing
              optional is set until you choose.
            </p>

            <div style={{ overflowX: "auto", margin: "20px 0" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.92rem" }}>
                <thead>
                  <tr style={{ textAlign: "left", borderBottom: "2px solid #e5e7eb" }}>
                    <th style={{ padding: "8px 10px" }}>Type</th>
                    <th style={{ padding: "8px 10px" }}>Name</th>
                    <th style={{ padding: "8px 10px" }}>Purpose</th>
                    <th style={{ padding: "8px 10px" }}>Lasts</th>
                  </tr>
                </thead>
                <tbody>
                  {COOKIES.map((row) => (
                    <tr key={row[1]} style={{ borderBottom: "1px solid #e5e7eb", verticalAlign: "top" }}>
                      {row.map((cell) => (
                        <td key={cell} style={{ padding: "8px 10px" }}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <h2 style={{ fontSize: "1.3rem", margin: "28px 0 8px" }}>Changing your choice</h2>
            <p>
              You can change or withdraw consent at any time. Withdrawing also removes the analytics and
              advertising cookies already on your device.{" "}
              <button
                type="button"
                onClick={openCookieSettings}
                style={{ background: "none", border: 0, padding: 0, color: "#15803d", textDecoration: "underline", cursor: "pointer", font: "inherit" }}
              >
                Open cookie settings
              </button>
            </p>

            <h2 style={{ fontSize: "1.3rem", margin: "28px 0 8px" }}>Questions</h2>
            <p>Write to us through the <a href="/contact">Contact page</a>.</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default CookiePolicyPage;
